<div *ngIf="values.showPlaca">
    <label [class.label-invalid]="!placas[0].placa">Placa motor</label>
    <div class="mb-3 d-flex align-items-center input-group has-validations">
        <input [disabled]="usuarioBloqueado" class="form-control" aria-describedby="basic-motor" type="text" (blur)="onBlurMotor(placas[0])" placeholder=" " [(ngModel)]="placas[0].placa" aria-describedby="basic-addon2" required>

        <div class="input-group-append">
            <span class="input-group-text" id="basic-motor">
                <fa-icon class="float-end" [icon]="['fas', 'truck']" size="lg"></fa-icon>
            </span>
        </div>
    </div>

    <div *ngIf="placas[0].tipo=='CAVALO'">
      <label [class.label-invalid]="!placas[1].placa">Placa carreta</label>
      <div class="mb-3 d-flex align-items-center input-group has-validations">
          <input [disabled]="usuarioBloqueado" class="form-control" type="text" (blur)="onBlurCarreta(placas[1])" placeholder=" " [(ngModel)]="placas[1].placa" aria-describedby="basic-addon2" required>
          
          <div class="input-group-append" [hidden]="placas[2].validar">
            <span class="input-group-text" style="cursor: pointer;" (click)="placas[2].validar=true">
              <fa-icon class="float-end" [icon]="['fas', 'plus']" size="lg"></fa-icon>
            </span>
          </div>
          <div class="input-group-append" [hidden]="!placas[2].validar">
              <span class="input-group-text">
                <fa-icon class="float-end" [icon]="['fas', 'truck']" size="lg"></fa-icon>
              </span>
            </div>
      </div>
    </div>

    <div *ngIf="placas[2].validar">
      <label [class.label-invalid]="!placas[2].placa">Placa carreta</label>
      <div class="mb-3 d-flex align-items-center input-group has-validations">
          <input [disabled]="usuarioBloqueado" class="form-control" type="text" (blur)="onBlurCarreta(placas[2])" placeholder=" " [(ngModel)]="placas[2].placa" aria-describedby="basic-addon2" required>
          
          <div class="input-group-append">
            <span class="input-group-text" style="cursor: pointer;" (click)="placas[2].validar=false">
              <fa-icon class="float-end" [icon]="['fas', 'minus']" size="lg"></fa-icon>
            </span>
          </div>
      </div>
    </div>

    <div class="container" [hidden]="validaPlacas()">
        <div class="row">
          <div class="col" style="padding: 0 !important">
            <div class="pb col next-button">
                <!--BOTÃO SEM EVENTO, APENAS PARA FORÇAR A PERDA DE FOCUS DOS CAMPOS DE PLACA-->
                <button type="button" class="btn btn-primary" [disabled]="!validaPlacas(false) || usuarioBloqueado">
                    VALIDAR &nbsp;
                    <fa-icon class="float-end" [icon]="['fas', 'check']" size="lg"></fa-icon>
                </button>
            </div>
          </div>
        </div>
    </div>

    <div class="container" [hidden]="!validaPlacas() || usuarioBloqueado">
      <div class="row">
        <div class="col" style="padding: 0 !important">
          <div class="pb col next-button">
              <button type="button" class="btn btn-primary" (click)="prosseguir()">
                  PROSSEGUIR &nbsp;
                  <fa-icon class="float-end" [icon]="['fas', 'arrow-circle-right']" size="lg"></fa-icon>
              </button>
          </div>
        </div>
      </div>
    </div>
</div>

<app-modal #modalAtualizacaoPlacaViagem [(modalConfig)]="modalConfig">
  <span style="color: red;">Placa de {{placas[0].tipo}} divergente, deseja realizar a atualização na SM?</span>
</app-modal>

<app-pre-checkout-veiculo-sinal *ngIf="values.showSinal"></app-pre-checkout-veiculo-sinal>
<app-pre-checkout-veiculo-sensor-engate *ngIf="values.showSensorEngate"></app-pre-checkout-veiculo-sensor-engate>
<app-pre-checkout-veiculo-sensor-bau *ngIf="values.showSensorBau"></app-pre-checkout-veiculo-sensor-bau>
<app-pre-checkout-veiculo-alvo-origem *ngIf="values.showAlvoOrigem"></app-pre-checkout-veiculo-alvo-origem>
<app-pre-checkout-veiculo-macro-inicio-viagem *ngIf="values.showMacroInicioViagem"></app-pre-checkout-veiculo-macro-inicio-viagem>